var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIConeligibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5889_14754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.5H28.25V17H26.75V26.75C26.75 26.9489 26.671 27.1397 26.5303 27.2803C26.3897 27.421 26.1989 27.5 26 27.5H15.5C15.3011 27.5 15.1103 27.421 14.9697 27.2803C14.829 27.1397 14.75 26.9489 14.75 26.75V17H13.25V15.5H17V13.25C17 13.0511 17.079 12.8603 17.2197 12.7197C17.3603 12.579 17.5511 12.5 17.75 12.5H23.75C23.9489 12.5 24.1397 12.579 24.2803 12.7197C24.421 12.8603 24.5 13.0511 24.5 13.25V15.5ZM25.25 17H16.25V26H25.25V17ZM18.5 19.25H20V23.75H18.5V19.25ZM21.5 19.25H23V23.75H21.5V19.25ZM18.5 14V15.5H23V14H18.5Z",
    fill: "#F12222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5889_14754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11.75 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIConeligibility);
export default __webpack_public_path__ + "static/media/deleteIConeligibility.1e0f20d29aefca5e8cf3b476399bbf7e.svg";
export { ForwardRef as ReactComponent };